/**
 * 押した後にサーバの応答を待ってから別のタブを開く操作のためのユーティリティ。
 * 応答を待ってから window.open すると押してからの時間が空き、ブラウザがポップアップとして止めることがある
 * （Firefox は押してから約 5 秒を過ぎると止める）。押した瞬間に空のタブを開いておき、行き先が決まったらそのタブを移す。
 * 呼ぶ側は openPendingWindow をクリックの処理の中で、最初の非同期処理より前に呼ぶ。
 */

/**
 * 空のタブを開く。ブラウザに止められたときは null
 * @param {Window} [opener]
 * @returns {Window|null}
 */
export function openPendingWindow(opener = window) {
  return opener.open('', '_blank');
}

/**
 * 開いておいたタブを行き先へ移す。タブが無い（止められた・先に閉じられた）ときは、これまでどおり新しく開く
 * 行き先は開いた側の URL を基準に絶対 URL へ直してから渡す（相対パスの解決を空のタブの側に任せない）
 * @param {Window|null} pending openPendingWindow の戻り値
 * @param {string} href
 * @param {Window} [opener]
 */
export function showInPendingWindow(pending, href, opener = window) {
  if (pending && !pending.closed) {
    pending.location.href = new URL(href, opener.location.href).href;
    return pending;
  }
  return opener.open(href, '_blank');
}

/**
 * 行き先が無いまま終わるとき（失敗・対象なし）に、開いておいた空のタブを閉じる
 * @param {Window|null} pending openPendingWindow の戻り値
 */
export function closePendingWindow(pending) {
  if (pending && !pending.closed) pending.close();
}
